import axios from 'axios';

const baseUrl = import.meta.env.VITE_API_BASE_URL;
// Origin for serving uploaded files (strip the trailing /api)
export const fileOrigin = (baseUrl || '').replace(/\/?api\/?$/, '');

export const fileUrl = (doc) => `${fileOrigin}${doc.FilePath}`;
export const downloadUrl = (doc) => `${baseUrl}/documents/${doc.DocumentID}/download`;

export const fetchDocuments = async (params = {}) =>
  (await axios.get(`${baseUrl}/documents`, { params })).data || [];

export const fetchStorage = async () =>
  (await axios.get(`${baseUrl}/documents/storage`)).data || { files: 0, bytes: 0, byCategory: [] };

// files: FileList/array; meta: { EntityType, LeadID, ClientID, Category, Remarks }
export const uploadDocuments = (files, meta = {}, onProgress) => {
  const fd = new FormData();
  Array.from(files).forEach((f) => fd.append('files', f));
  Object.entries(meta).forEach(([k, v]) => { if (v != null && v !== '') fd.append(k, v); });
  return axios.post(`${baseUrl}/documents`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress,
  });
};

export const deleteDocument = (id) => axios.delete(`${baseUrl}/documents/${id}`);
